import React from 'react';

import {findFixedFilter, fixedFilters} from '../../utils/filter-utils';

import CheckBoxList from '../../../../../stories/components/hotels/common/CheckBoxList/CheckBoxList';

const StarRatingFilter = ({updateFilter, starRatingFilter}) => {
  const onFilterSelect = (item, itemUnderAction, isSelected) => {
    updateFilter({star: item.map(subItem => subItem.key)});
  };

  return (
    <CheckBoxList
      name="STAR RATING"
      data={fixedFilters.star.data}
      lookup={item => `${fixedFilters.star.name}${item.key}`}
      type={fixedFilters.star.type}
      renderItem={item => (
        <>
          {item.name}
          {/* <S.StarRatingWrapperSpan>
            {[...Array(item.key)].map((item, index) => (
              <RatingStarIcon key={'starIcon' + index} />
            ))}
          </S.StarRatingWrapperSpan> */}
        </>
      )}
      actionHandler={onFilterSelect}
      resetHandlerProp={() => {
        updateFilter({star: []});
      }}
      defaultState={
        (starRatingFilter &&
          starRatingFilter.map(item =>
            findFixedFilter({
              target: item,
              src: fixedFilters.star.data,
              type: fixedFilters.star.name,
            }),
          )) ||
        []
      }
      maxLength={3}
    />
  );
};

export default React.memo(StarRatingFilter);
